import React from 'react';
import { Box, Typography, Divider } from '@mui/material';
import { format, parseISO } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { getDateLocale } from '../../../lib/dateLocale';
import { formatPriceByLocale, fullName } from '../../../lib/utils';

export default function EventInscriptions({ inscriptions }: any) {
    const { t } = useTranslation();
    if (!inscriptions) {
        return null;
    }

    return (
        <>
            <Box mb={3}>
                <Typography variant="body1">
                    {t('page.event.oldInscriptions').toUpperCase()}
                </Typography>
            </Box>
            <Box>
                {inscriptions.map((insc: any, i: any) => (
                    <Box key={insc.id || i} mb={3}>
                        <Box
                            mb={1}
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                            }}
                        >
                            <Typography>
                                <b>{t('event.inscription')}</b>
                            </Typography>
                            <Typography style={{ color: '#000' }}>
                                {format(parseISO(insc.created), 'dd MMM yyyy', {
                                    locale: getDateLocale(),
                                })}
                            </Typography>
                        </Box>
                        <Box>
                            {insc.participants &&
                                insc.participants.map(
                                    (participant: any, index: any) => {
                                        const isPaid =
                                            participant.category?.price === 0 ||
                                            (participant.enrollment &&
                                                participant.enrollment
                                                    ?.status === 'PAID');
                                        return (
                                            <React.Fragment
                                                key={participant.id || index}
                                            >
                                                {index > 0 && (
                                                    <Box my={1}>
                                                        <Divider />
                                                    </Box>
                                                )}
                                                <Box
                                                    p={1}
                                                    display="flex"
                                                    flexWrap="wrap"
                                                    justifyContent="space-between"
                                                >
                                                    <Typography variant="body2">
                                                        {fullName(participant)}
                                                    </Typography>
                                                    <Typography>
                                                        {
                                                            participant.category
                                                                ?.name
                                                        }
                                                    </Typography>
                                                    <Typography
                                                        sx={{
                                                            color: isPaid
                                                                ? '#4caf50'
                                                                : '#f44336',
                                                        }}
                                                    >
                                                        {participant.category
                                                            ?.enrollment > 0
                                                            ? formatPriceByLocale(
                                                                  participant
                                                                      ?.category
                                                                      ?.enrollment,
                                                                  participant
                                                                      ?.category
                                                                      ?.enrollmentShape
                                                                      ?.currency,
                                                                  participant
                                                                      ?.category
                                                                      ?.enrollmentShape
                                                                      ?.locale,
                                                              )
                                                            : t('payment.free')}
                                                    </Typography>
                                                </Box>
                                            </React.Fragment>
                                        );
                                    },
                                )}
                        </Box>
                    </Box>
                ))}
            </Box>
        </>
    );
}
